module.exports = __webpack_public_path__ + "img/opiniooon-logo-white.6b26befe.svg";